module.exports = __webpack_public_path__ + "img/icon_1225.2faa3367.svg";